
import swal from "sweetalert";
import TableApp from "@/components/Table/Table2";
import FilterFields from "@/components/FilterFields";
import balancaService from "@/core/services/balanca.service";
import balancaTerminalService from "@/core/services/balanca-terminal.service";

export default {
  name: "balanca-index",
  components: { TableApp, FilterFields },
  data() {
    return {
      fields: [
        {
          label: "Dispositivo",
          field: "nome",
          sortable: true,
          slot: true,
          width: "30%",
        },
        {
          label: "Computador",
          field: "porta_serial",
          sortable: false,
          slot: true,
          width: "30%",
        },
        {
          label: "Status",
          field: "status",
          sortable: true,
          slot: true,
          width: "15%",
        },
        {
          label: "Ações",
          field: "actions",
          sortable: false,
          slot: true,
          width: "25%",
        },
      ],
      modelos: [],
      downloads: { windows: null, macos: null, version: null },
      diagnosticoLocal: null,
      pareando: false,
      salvando: false,
      form: {},
    };
  },
  computed: {
    opcoesModelos() {
      return this.modelos.map((modelo) => ({
        value: modelo.codigo,
        text: `${modelo.nome} (${modelo.fabricante})`,
      }));
    },
    statusLocal() {
      if (this.diagnosticoLocal?.conectado) {
        return {
          classe: "is-ready",
          titulo: "Pronta para usar",
          mensagem: this.diagnosticoLocal.porta || "Balança conectada",
        };
      }
      if (this.diagnosticoLocal?.pareado) {
        return {
          classe: "is-warning",
          titulo: "Aplicativo encontrado",
          mensagem:
            this.diagnosticoLocal.ultimoErro || "Conecte ou ligue a balança",
        };
      }
      return {
        classe: "is-offline",
        titulo: "Ainda não conectada",
        mensagem: "Instale o aplicativo e conecte este computador",
      };
    },
  },
  async created() {
    balancaService.configurar({
      host: "127.0.0.1",
      porta: 51234,
      accessToken: balancaTerminalService.localAccessToken(),
    });
    await Promise.all([this.carregarModelos(), this.carregarDownloads()]);
    await this.verificarAgenteLocal();
  },
  methods: {
    async carregarModelos() {
      try {
        const { data } = await this.$http.post("/balanca/modelos");
        this.modelos = data || [];
      } catch (_) {
        this.modelos = [];
      }
    },
    async carregarDownloads() {
      try {
        const { data } = await this.$http.post("/balanca/downloads");
        this.downloads = data || this.downloads;
      } catch (_) {
        /* O cadastro continua disponível mesmo sem artefatos publicados. */
      }
    },
    baixarAgente(url) {
      if (url) window.open(url, "_blank", "noopener");
    },
    nomeModelo(codigo) {
      return (
        this.modelos.find((modelo) => modelo.codigo === codigo)?.nome ||
        codigo ||
        "—"
      );
    },
    onModeloChange(codigo) {
      const modelo = this.modelos.find((item) => item.codigo === codigo);
      if (modelo) {
        this.form.baud_rate = modelo.baud_rate_default;
        this.form.casas_decimais = modelo.casas_decimais_default;
      }
    },
    async dispositivoDesteComputador() {
      const { data } = await this.$http.post("/balanca/dispositivos/lista", {
        terminal_web_uuid: balancaTerminalService.terminalUuid(),
        ativo: true,
        per_page: 1,
      });
      return data?.data?.[0] || null;
    },
    async conectarEsteComputador() {
      this.pareando = true;
      try {
        let dispositivo = await this.dispositivoDesteComputador();
        let resposta;
        if (dispositivo) {
          resposta = await this.$http.post("/balanca/dispositivos/parear", {
            id: dispositivo.id,
          });
        } else {
          resposta = await this.$http.post("/balanca/dispositivos/create", {
            nome: "PDV Web deste computador",
            modelo: "toledo_prix_3_fit",
            terminal_web_uuid: balancaTerminalService.terminalUuid(),
          });
          dispositivo = resposta.data;
        }
        const codigo =
          resposta.data?.codigo_pareamento ||
          resposta.data?.data?.codigo_pareamento;
        if (!codigo)
          throw new Error("O servidor não gerou o código de pareamento.");
        this.abrirAgente(codigo);
        await this.aguardarAgente();
        this.$refs.balanca?.refresh?.();
      } catch (error) {
        swal({
          text: error?.message || "Não foi possível conectar este computador.",
          icon: "error",
        });
      } finally {
        this.pareando = false;
      }
    },
    abrirAgente(codigo) {
      balancaTerminalService.abrirAgente(codigo);
    },
    async aguardarAgente() {
      for (let tentativa = 0; tentativa < 15; tentativa += 1) {
        await new Promise((resolve) => setTimeout(resolve, 2000));
        if (await this.verificarAgenteLocal()) return true;
      }
      swal({
        text: "O aplicativo não respondeu. Confirme que ele foi instalado e está aberto.",
        icon: "warning",
      });
      return false;
    },
    async verificarAgenteLocal() {
      try {
        this.diagnosticoLocal = await balancaService.diagnostico();
        return Boolean(this.diagnosticoLocal?.pareado);
      } catch (_) {
        this.diagnosticoLocal = null;
        return false;
      }
    },
    async parearDispositivo(row) {
      this.pareando = true;
      try {
        await this.$http.post("/balanca/dispositivos/update", {
          id: row.id,
          terminal_web_uuid: balancaTerminalService.terminalUuid(),
        });
        const { data } = await this.$http.post("/balanca/dispositivos/parear", {
          id: row.id,
        });
        this.abrirAgente(
          data?.codigo_pareamento || data?.data?.codigo_pareamento
        );
        await this.aguardarAgente();
        this.$refs.balanca?.refresh?.();
      } catch (error) {
        swal({
          text: error?.message || "Não foi possível conectar esta balança.",
          icon: "error",
        });
      } finally {
        this.pareando = false;
      }
    },
    abrirModalEditar(row) {
      this.form = {
        id: row.id,
        nome: row.nome,
        modelo: row.modelo,
        baud_rate: row.baud_rate,
        casas_decimais: row.casas_decimais,
      };
      this.$refs.modalDispositivo.show();
    },
    async salvar(event) {
      if (event?.preventDefault) event.preventDefault();
      if (!this.form.nome) return;
      try {
        this.salvando = true;
        await this.$http.post("/balanca/dispositivos/update", this.form);
        this.$refs.balanca?.refresh?.();
        this.$refs.modalDispositivo.hide();
      } finally {
        this.salvando = false;
      }
    },
    excluir(row) {
      swal({
        title: "Excluir balança?",
        text: `O caixa "${row.nome}" deixará de receber o peso.`,
        icon: "warning",
        buttons: { cancel: "Cancelar", confirm: "Excluir" },
        dangerMode: true,
      }).then(async (confirma) => {
        if (!confirma) return;
        await this.$http.post("/balanca/dispositivos/delete", { id: row.id });
        this.$refs.balanca?.refresh?.();
      });
    },
  },
};
